export function mergeWeatherData({
    averageMonthlyRainfall = [],
    averageMinMonthlyTemperature = [],
    averageMaxMonthlyTemperature = []
}) {
    const map = new Map();

    // helper to ensure entry exists
    const ensure = (month) => {
        if (!map.has(month)) {
            map.set(month, {
                month,
                rainfall: 0,
                minTemp: null,
                maxTemp: null
            });
        }
        return map.get(month);
    };

    // rainfall
    averageMonthlyRainfall.forEach((item) => {
        const entry = ensure(item.month);
        entry.rainfall = item.rainfall;
    });

    // min temp
    averageMinMonthlyTemperature.forEach((item) => {
        const entry = ensure(item.month);
        entry.minTemp = item.temperature;
    });

    // max temp (if available)
    averageMaxMonthlyTemperature.forEach((item) => {
        const entry = ensure(item.month);
        entry.maxTemp = item.temperature;
    });

    return Array.from(map.values());
}